module.exports = {"appName":"Program Ishrane","webDesign":"Web-Design"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/translations/de.json
// module id = E5Yw
// module chunks = 0